import {
  faCheckCircle,
  faExclamationCircle,
  faInfoCircle,
  faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { PropsWithChildren } from 'react'

import './Callout.css'

type Props = {
  variant?: 'info' | 'danger' | 'warning' | 'success'
  showIcon?: boolean
  maxWidth?: string
  width?: string
} & PropsWithChildren

const defaultIcons = {
  info: faInfoCircle,
  success: faCheckCircle,
  warning: faTriangleExclamation,
  danger: faExclamationCircle,
}

export function Callout({ variant = 'info', showIcon = true, children, maxWidth, width }: Props) {
  const Icon = defaultIcons[variant]

  return (
    <div className="Callout" data-variant={variant} style={{ maxWidth, width }}>
      {showIcon && (
        <span className="Callout-icon">
          <FontAwesomeIcon icon={Icon} size="sm" />
        </span>
      )}
      <div className="Callout-content">{children}</div>
    </div>
  )
}
